export default {
  RespostaDeliberacao: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "resposta-deliberacao"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/RespostaDeliberacao.js
// module id = TkQZ
// module chunks = 16